import { css } from '@emotion/react'

import AppImage from 'gatsby-theme-marketplace-base/src/components/HomePage/Campaigns/Campaign/AppImage'
import mediaQueries from '../../../../layout/media-queries'

const overrideCss = () => css`
  ${mediaQueries.xsmallScreen(200)} {
    width: 100%;
    height: 100%;
  }

  ${mediaQueries.smallScreen()} {
    width: 47%;
  }

  ${mediaQueries.largeScreen()} {
    width: 60%;
  }
`

export default (props) => <AppImage {...props} css={overrideCss} />
